/* eslint-disable */
import _ from 'underscore';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
function mapCampaignApiErrorCode(errorCode, args) {
  var i18nArgs = ['Error_Campaign_API_' + errorCode, errorCode ? errorCode : i18n.getString('Error')];
  if (args) {
    i18nArgs = i18nArgs.concat(args);
  }
  return i18n.getStringOrDefault.apply(i18n, i18nArgs);
}
function mapCampaignApiErrorCodeShort(errorCode, args) {
  var i18nArgs = ['Error_Campaign_API_' + errorCode + '_Short'].concat(args);
  return i18n.getString.apply(i18n, i18nArgs);
}
function mapEditorialErrorCode(apiErrorCode, rawErrorCode) {
  return rawErrorCode ? i18n.getString('Error_Editorial_Raw_' + rawErrorCode) : i18n.getString('Error_Editorial_API_' + apiErrorCode);
}
function _mapSingleEditorialError(error, countryKey, countryName) {
  return _.extend({
    countryKey: countryKey,
    countryName: countryName,
    message: mapEditorialErrorCode(error.Error, error.RawEditorialErrorCode)
  }, error);
}
function _mapSingleCountryErrors(countryErrors) {
  var countryName = i18n.getString('PublisherCountry_' + countryErrors.Key);
  return {
    countryKey: countryErrors.Key,
    countryName: countryName,
    errors: _.map(countryErrors.Value, function (error) {
      return _mapSingleEditorialError(error, countryErrors.Key, countryName);
    })
  };
}
function mapEditorialErrors(errors, flatten) {
  if (!_.isArray(errors) || errors.length === 0) {
    return [];
  }
  var grouppedErrors = _.map(errors, _mapSingleCountryErrors);
  return !flatten ? grouppedErrors : _.chain(grouppedErrors).pluck('errors').flatten().value();
}
export default {
  mapCampaignApiErrorCode: mapCampaignApiErrorCode,
  mapEditorialErrorCode: mapEditorialErrorCode,
  mapEditorialErrors: mapEditorialErrors,
  mapCampaignApiErrorCodeShort: mapCampaignApiErrorCodeShort
};

